import EventBus from "../../../../util/EventBus";
import Applet from "../../Applet";
import EnlilDetailDialog from "../../../../components/EnlilDetailDialog";

class ProjectPlanPhaseFormApplet extends Applet {
    state = {
        Name: "ProjectPlanPhaseFormApplet",
        Actions: {
            View: {
                Groups: [
                    {
                        "identifier": "group1",
                        "type": "standard",
                        "selector": null,
                        "characteristics": [],
                        "membership": [
                            {
                                id: "Name",
                            },
                            {
                                id: "Description",
                            },
                            {
                                id: "StartDatetime",
                            },
                            {
                                id: "DueDatetime",
                            },
                            {
                                id: "Notes",
                            },
                            {
                                id: "Justification",
                            }
                        ]
                    }
                ]
            },
            New: {
                Groups: [
                    {
                        "identifier": "group1",
                        "type": "standard",
                        "selector": null,
                        "characteristics": [],
                        "membership": [
                            {
                                id: "Name",
                            },
                            {
                                id: "Description",
                            },
                            {
                                id: "StartDatetime",
                            },
                            {
                                id: "DueDatetime",
                            },
                            {
                                id: "Notes",
                            },
                            {
                                id: "Justification",
                            }
                        ]
                    }
                ]
            },
            Edit: {
                Groups: [
                    {
                        "identifier": "group1",
                        "type": "standard",
                        "selector": null,
                        "characteristics": [],
                        "membership": [
                            {
                                id: "Name",
                            },
                            {
                                id: "Description",
                            },
                            {
                                id: "StartDatetime",
                            },
                            {
                                id: "DueDatetime",
                            },
                            {
                                id: "Notes",
                            },
                            {
                                id: "Justification",
                            }
                        ]
                    }
                ]
            }
        },
        Layout: {
            totalWidth: "36em",
        },
        Controls: {
            Name: {
                id: "Name",
                enterpriseComponentAttribute: "Name",
                placement: {
                    "View": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "Edit": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "New": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                },
                errors: [
                    {
                        validator: "Unique",
                        value: null,
                        errorText: "Field must be unique.",
                    },
                    {
                        validator: "No Leading Spaces",
                        value: null,
                        errorText: "Field must not have leading spaces.",
                    },
                    {
                        validator: "Not All Spaces",
                        value: null,
                        errorText: "Field must not have all spaces.",
                    },
                ],
                csp: {
                    label: "Name",
                    size: "small",
                },
                ip: {},
                type: "TextField",
                requiresConfirmation: true,
            },
            Description: {
                id: "Description",
                enterpriseComponentAttribute: "Description",
                placement: {
                    "View": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "Edit": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "New": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                },
                errors: [
                    {
                        validator: "No Leading Spaces",
                        value: null,
                        errorText: "Field must not have leading spaces.",
                    },
                    {
                        validator: "Not All Spaces",
                        value: null,
                        errorText: "Field must not have all spaces.",
                    },
                ],
                csp: {
                    label: "Description",
                    size: "small",
                },
                ip: {},
                type: "TextField",
                requiresConfirmation: false,
            },
            StartDatetime: {
                id: "StartDatetime",
                enterpriseComponentAttribute: "StartDatetime",
                placement: {
                    "View": {
                        xs: 12,
                        sm: 12,
                        md: 6,
                        lg: 6,
                        xl: 6,
                    },
                    "Edit": {
                        xs: 12,
                        sm: 12,
                        md: 6,
                        lg: 6,
                        xl: 6,
                    },
                    "New": {
                        xs: 12,
                        sm: 12,
                        md: 6,
                        lg: 6,
                        xl: 6,
                    },
                },
                errors: [],
                csp: {
                    label: "Start Date",
                    size: "small",
                },
                ip: {},
                type: "Date",
                requiresConfirmation: false,
            },
            DueDatetime: {
                id: "DueDatetime",
                enterpriseComponentAttribute: "DueDatetime",
                placement: {
                    "View": {
                        xs: 12,
                        sm: 12,
                        md: 6,
                        lg: 6,
                        xl: 6,
                    },
                    "Edit": {
                        xs: 12,
                        sm: 12,
                        md: 6,
                        lg: 6,
                        xl: 6,
                    },
                    "New": {
                        xs: 12,
                        sm: 12,
                        md: 6,
                        lg: 6,
                        xl: 6,
                    },
                },
                errors: [],
                csp: {
                    label: "Due Date",
                    size: "small",
                },
                ip: {},
                type: "Date",
                requiresConfirmation: false,
            },
            Status: {
                id: "Status",
                enterpriseComponentAttribute: "Status",
                placement: {
                    "View": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "Edit": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "New": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                },
                errors: [],
                csp: {
                    label: "Status",
                    size: "small",
                },
                ip: {},
                type: "Select",
                requiresConfirmation: false,
            },
            Notes: {
                id: "Notes",
                enterpriseComponentAttribute: "Notes",
                placement: {
                    "View": {
                        xs: 12,
                        sm: 12,
                        md: 6,
                        lg: 6,
                        xl: 6,
                    },
                    "Edit": {
                        xs: 12,
                        sm: 12,
                        md: 6,
                        lg: 6,
                        xl: 6,
                    },
                    "New": {
                        xs: 12,
                        sm: 12,
                        md: 6,
                        lg: 6,
                        xl: 6,
                    },
                },
                errors: [],
                csp: {
                    label: "Notes",
                    size: "small",
                },
                ip: {},
                type: "TextField",
                requiresConfirmation: false,
            },
            Justification: {
                id: "Justification",
                enterpriseComponentAttribute: "Justification",
                placement: {
                    "View": {
                        xs: 12,
                        sm: 12,
                        md: 6,
                        lg: 6,
                        xl: 6,
                    },
                    "Edit": {
                        xs: 12,
                        sm: 12,
                        md: 6,
                        lg: 6,
                        xl: 6,
                    },
                    "New": {
                        xs: 12,
                        sm: 12,
                        md: 6,
                        lg: 6,
                        xl: 6,
                    },
                },
                errors: [],
                csp: {
                    label: "Justification",
                    size: "small",
                },
                ip: {},
                type: "TextField",
                requiresConfirmation: false,
            },
        }
    };

    cancel() {
        super.cancel();

        EventBus.components.emit("project-plan-phase-form-applet-cancel");
    };

    setAction(mode) {
        super.setAction(mode);

        if (mode === "Save Completed") {
            EventBus.components.emit("project-plan-phase-form-applet-save");
        }
    };

    render() {
        return <EnlilDetailDialog applet={this}
                                layout={this.state.Layout}
                                controls={this.state.Controls}
                                actions={this.state.Actions}
                                title="Project Plan Phase"
                                enterpriseComponent={this.getEnterpriseComponent()}
                                action={this.props.defaultAction}
                                errorReportingMethod="RealTime" />;
    }
}

export default ProjectPlanPhaseFormApplet;
